export default __webpack_public_path__ + "static/media/flower.09ea2f4a.jpg";